<div class="flex flex-wrap">
  <div class="relative w-full xl:w-5/12 authBackground">
    <app-carousel></app-carousel>
  </div>

  <div class="relative w-full xl:w-7/12">
    <div class="login-card">
      <div class="login-main">
        <app-registration-form (success)="onSuccess($event)"></app-registration-form>
      </div>
    </div>
  </div>
</div>
